import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import { Keyframes, css, keyframes } from 'styled-components'
import { bezierCurve } from 'styles/tools/constants'

const ANIMATION_DURATION = 20
const GRID_COLUMNS = 10

export const setValueAnimation = () => {
  const animationDuration: number = ANIMATION_DURATION
  const gridColumns: number = GRID_COLUMNS
  const ItemTransition: Keyframes = keyframes`
    0% {
        transform: translateX(0);
    }

    12% {
        transform: translateX(0);
    }

    /* Transition to slide 2 */
    20% {
        transform: translateX(-100%);
    }

    27% {
        transform: translateX(-100%);
    }

    /* Transition to slide 3 */
    40% {
        transform: translateX(-200%);
    }

    47% {
        transform: translateX(-200%);
    }

    /* Transition to slide 4 */
    60% {
        transform: translateX(-300%);
    }

    67% {
        transform: translateX(-300%);
    }

    /* Transition to slide 5 */
    80% {
        transform: translateX(-400%);
    }

    90% {
        transform: translateX(-400%);
    }

    /* Transition to "start" */
    100% {
        transform: translateX(-500%);
    }
  `
  return css` 
    display: grid;
    overflow: visible;
    animation: ${ItemTransition} ${animationDuration}s ${bezierCurve} infinite;
    grid-template-columns: repeat(${gridColumns}, 100%);
    width: 78%;

    ${mediaQueryUp.sm} {
        width: 52%;
    }
    
    ${mediaQueryUp.md} {
      justify-content: space-between;
      grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
      overflow: unset;
      animation: unset;
      width: 100%;
    }
  `
}

const setBubbleTransition = (): Keyframes => {
  const BubbleTransition: Keyframes = keyframes`
    0% {
        width: ${rem(16)};
    }

    15% {
        width: ${rem(16)};
    }

    20% {
        width: ${rem(8)};
    }

    94% {
        width: ${rem(8)};
    }

    100% {
        width: ${rem(16)};
    }
  `
  return BubbleTransition
}

const setBubbleProgressTransition = (): Keyframes => {
  const BubbleProgressTransition: Keyframes = keyframes`
    0% {
        transform: translateX(-100%);
        opacity: 1;
    }

    /* Slide across the bubble */
    15% {
        transform: translateX(0%);
        opacity: 1;
    }

    /* Fade out as we change slides */
    20% {
        transform: translateX(0%);
        opacity: 0;
    }

    100% {
        transform: translateX(-100%);
        opacity: 0;
    }
  `
  return BubbleProgressTransition
}

const setAnimationDelay = () => {
  const AnimationDelay = css`
      &:nth-child(2) {
          animation-delay: 4s;

          &::after {
              animation-delay: 4s;
          }
      }

      &:nth-child(3) {
          animation-delay: 8s;

          &::after {
              animation-delay: 8s;
          }
      }

      &:nth-child(4) {
          animation-delay: 12s;

          &::after {
              animation-delay: 12s;
          }
      }

      &:nth-child(5) {
          animation-delay: 16s;

          &::after {
              animation-delay: 16s;
          }
      }
  `
  return AnimationDelay
}

export const setBubbleAnimation = () => {
  const BubbleTransition = setBubbleTransition()
  const BubbleProgressTransition = setBubbleProgressTransition()
  const AnimationDelay = setAnimationDelay()
  const animationDuration = ANIMATION_DURATION

  return css`
    position: relative;
    height: ${rem(8)};
    width: ${rem(8)};
    border-radius: ${props => props.theme.borderRadius.round};
    background-color: ${props => props.theme.palette.neutral.eight};
    animation: ${BubbleTransition} ${animationDuration}s linear infinite;
    border: 1px solid ${props => props.theme.palette.neutral.one};
    overflow: hidden;
    transform: translateZ(0);

    ${AnimationDelay}

    &::after {
        display: block;
        content: '';
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        transform: translateX(-100%);
        background-color: ${props => props.theme.palette.neutral.one};
        animation: ${BubbleProgressTransition} ${animationDuration}s linear infinite;
    }
  `
}
